import clsx from "clsx";
import Button from "components/Button";
import { CARRIER_PAYMENT_SPEED } from "constants/haulpay-carrier";
import dayjs from "dayjs";
import { formatNumber } from "helpers/formatNumber";

import { CARRIER_FR_STATUS_LABELS } from "constants/base";
import { useColorScheme } from "hooks/useColorScheme";
import { IFundingRequestItem } from "models/HaulPay";
import styles from "./style.module.scss";
import { getClassByStatus } from "helpers/getClassByVariant";
import PaymentSpeedInput from "components/PaymentSpeedInput";

interface IProps {
  data: IFundingRequestItem;
  goToMoreDetails?: VoidFunction;
}

export default function AssignedLoadItem({ data, goToMoreDetails }: Readonly<IProps>) {
  const { currentIsDark } = useColorScheme();
  const statusLabel = CARRIER_FR_STATUS_LABELS[data?.status?.toLowerCase().replace(/\s+/g, "_")];
  const currentPaymentSpeed = CARRIER_PAYMENT_SPEED.find(
    (speed) => speed.value === String(data.payoutDays)
  );

  return (
    <ul className={clsx(styles.container, !currentIsDark && "drop-shadow-[0_2px_4.5px_#9E9E9E33]")}>
      <div className={styles.statusSection}>
        <div className="text-base font-medium">
          <span className="font-semibold">Status{" - "}</span>
          <span className={clsx("uppercase", getClassByStatus(statusLabel))}>{statusLabel}</span>
        </div>
      </div>
      <li className="items-start">
        <span className="font-semibold">Bill To</span>
        <span className="break-words">{data?.debtor?.name}</span>
      </li>
      <li>
        <span className="font-semibold">Invoice Amount</span>
        <span>{formatNumber(data.amount, 2)}</span>
      </li>
      <li>
        <span className="font-semibold">Invoice #</span>
        <span>{data.invoiceNumber}</span>
      </li>
      <li>
        <span className="font-semibold">Load #</span>
        <span>{data.userLoadNumber}</span>
      </li>
      <li>
        <span className="font-semibold">Requested At</span>
        <span>{dayjs(data.created).format("MM/DD/YYYY hh:mm A")}</span>
      </li>
      <li>
        <span className="font-semibold">Funded At</span>
        <span>{data.fundedAt ? dayjs(data.fundedAt).format("MM/DD/YYYY hh:mm A") : "-"}</span>
      </li>
      <li>
        <span className="font-semibold">Rate</span>
        <span>{data.discountRate} %</span>
      </li>
      <li>
        <span className="font-semibold">Payment Amount</span>
        <span>{formatNumber(Number(data.amountFunded), 2)}</span>
      </li>
      <li>
        <span className="font-semibold">Payment Speed</span>
        <div className={styles.actionSection}>
          <PaymentSpeedInput
            noLabel
            name="payment_speed"
            inputProps={{
              disabled: true,
              btnClass: "!py-2 !pl-2 !pr-4 !text-xs",
              dropdownClass: "!p-2",
              className: "w-full",
              arrowClass: "!right-0",
              value: currentPaymentSpeed
            }}
            factoringId={data?.factoring?.id}
          />
        </div>
      </li>
      <li>
        <span className="font-semibold">Details</span>
        <Button variant="outline" className={styles.moreButton} rounded onClick={goToMoreDetails}>
          More
        </Button>
      </li>
    </ul>
  );
}
